import { useGetInvoiceReportSummarySuspense } from 'ap-openapi';

export type PayeeContactOfficeMember = {
  id: string;
};

/**
 * Backs the "add payee's in-house contacts" one-click action: the report's
 * payee (report_summary's `payee`, serialized via `ApPayeeDetailResource`)
 * already carries its `contact_office_members` inline, so this just reads
 * that instead of a separate per-payee round trip.
 *
 * A report has exactly one payee (`ApReportSummary#ap_payee`, a single
 * polymorphic belongs_to) — every line item's `ap_payee` is that same
 * record — so reading the report-level payee alone (rather than
 * aggregating per-transaction payees) doesn't drop any contacts.
 */
export const useInvoiceReportPayeeContacts = (
  reportId: string
): PayeeContactOfficeMember[] => {
  const { data, error } = useGetInvoiceReportSummarySuspense(reportId);
  if (error) throw error;

  return (data.data?.payee?.contact_office_members ?? [])
    .filter((contact): contact is { id: string } => !!contact.id)
    .map((contact) => ({ id: contact.id }));
};
